import apiClient from "./client";
import type {
  Category,
  CreateCategoryRequest,
  UpdateCategoryRequest,
} from "@/types";

export const categoriesApi = {
  getCategories: async (): Promise<Category[]> => {
    const response = await apiClient.get<{ categories: Category[] }>(
      "/category/forRestaurant"
    );
    return response.data.categories;
  },

  createCategory: async (data: CreateCategoryRequest): Promise<Category> => {
    const response = await apiClient.post<Category>("/category", data);
    return response.data;
  },

  updateCategory: async (
    id: number,
    data: UpdateCategoryRequest
  ): Promise<Category> => {
    const response = await apiClient.patch<Category>(`/category/${id}`, data);
    return response.data;
  },

  deleteCategory: async (id: number): Promise<void> => {
    await apiClient.delete(`/category/${id}`);
  },
};
